import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';

interface QCStatusButtonProps {
  type: 'Bean' | 'Cupping';
  status: boolean | null | undefined;
  onClick: () => void;
  readOnly?: boolean;
}

// Bean QC edits a green bean profile; Cupping QC edits a cupping session.
// Gate on the profile resource, not the parent inventory/samples permission.
const QC_WRITE_RESOURCE: Record<'Bean' | 'Cupping', string> = {
  Bean: 'green_bean_profiles',
  Cupping: 'cupping_sessions',
};

export const QCStatusButton: React.FC<QCStatusButtonProps> = ({ type, status, onClick, readOnly = false }) => {
  const { can } = usePermissions();
  const effectiveReadOnly = readOnly || !can(QC_WRITE_RESOURCE[type], 'write');

  let label = `${type} QC`;
  let className = "px-3 py-1 rounded text-xs font-medium border transition-colors ";

  if (status === true) {
    label = `${type} QC Passed`;
    className += "bg-green-100 text-green-800 border-green-200 hover:bg-green-200";
  } else if (status === false) {
    label = `${type} QC Failed`;
    className += "bg-red-100 text-red-800 border-red-200 hover:bg-red-200";
  } else {
    className += "bg-gray-100 text-gray-600 border-gray-200 hover:bg-gray-200";
  }

  if (effectiveReadOnly) {
    className += " opacity-60 cursor-default";
  }

  return (
    <button type="button" onClick={(e) => { e.stopPropagation(); if (!effectiveReadOnly) onClick(); }} className={className} disabled={effectiveReadOnly}>
      {label}
    </button>
  );
};
